<template>
    <div class="form-row reporting-restrictions-item">
        <div class="form-row__col form-row__col--one-quarter">
            <label class="label">{{ trans('users.reporting_restrictions.select_type') }}</label>
            <v-select v-model="typeSelected"
                :options="typeOptions"
                :placeholder="trans('users.reporting_restrictions.placeholder')"
                class="form-vue-select"
                @input="typeSelectionChanged"
            >
                <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
            </v-select>
        </div>
        <div class="form-row__col form-row__col--one-half">
            <label class="label">{{ trans('users.reporting_restrictions.select_item') }}</label>
            <v-select v-model="restrictionSelected"
                :options="restrictionOptions"
                :placeholder="trans('users.reporting_restrictions.placeholder')"
                class="form-vue-select"
            >
                <div slot="no-options">{{ trans('vue_select.no_options') }}</div>
            </v-select>
        </div>
        <div class="form-row__col form-row__col--one-quarter">
            <div>
                <label class="label">&nbsp;</label>
                <button @click.prevent="deleteItem" :title="trans('buttons.delete')">
                    <div class="icon-button icon-button--primary">
                        <div class="icon-button__icon">
                            <img src="/images/icons/error.svg" alt="">
                        </div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'userId',
        'item',
        'index',
    ],

    data() {
        return {
            typeSelected: null,
            restrictionSelected: null,
            typeOptions: [
                {label: this.trans('users.reporting_restrictions.usergroup'), value: 'usergroup'},
                {label: this.trans('users.reporting_restrictions.client'), value: 'client'},
            ],
            restrictionOptions: [
            ],
        }
    },

    methods: {
        typeSelectionChanged() {
            this.restrictionSelected = null;
            this.getTypeOptions();
        },
        getTypeOptions() {
            if (!this.typeSelected) {
                return;
            }
            axios.get(this.route('tenantapi.users.reporting_restrictions.gettype', {'user': this.userId, 'type': this.typeSelected.value}))
                .then((response) => {
                    console.log(response.data.data);
                    this.restrictionOptions = response.data.data;
                })
                .catch((error) => {
                    console.log('blub');
                });
        },
        deleteItem() {
            this.$emit('item:delete');
        },
    },

    mounted() {
        this.typeSelected = this.item.type;
        this.restrictionSelected = this.item.restriction;
        this.getTypeOptions();
    },

    watch: {
        typeSelected() {
            this.item.type = this.typeSelected;
        },
        restrictionSelected() {
            this.item.restriction = this.restrictionSelected;
        },
    },
}
</script>
